module.exports = __webpack_public_path__ + "static/media/296359.df544675.png";